import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';

import {
    CanActivateFn,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { AuthService } from './auth.service';
import { map, catchError } from 'rxjs/operators';

export const authGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean> | boolean => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.subscribeToLoginService().pipe(
        map((userInfo) => {
            if (userInfo != null && userInfo.userId != null) {
                return true;
            }
            router.navigate(['/401']);
            return false;
        }),
        catchError(err => {
            console.log('error: ' + err);
            return of(false);
        })
    );
};

/**
 * @deprecated Use the functional `authGuard` instead.
 * Kept for backward compatibility with any class-token references.
 */
export class AuthGuard {
    static ɵfac = () => authGuard;
}
